export default __webpack_public_path__ + "static/media/kompleksowa-organizacja.3adf1aa1.md";